<lib-toastr
    [toastrType]="toastPackage.toastType"
    [title]="title"
    [message]="message"
    [htmlBodyContent]="options.enableHtml"
    [closeButton]="options.closeButton"
    [onCloseFunction]="onClose"
>
</lib-toastr>
